export default __webpack_public_path__ + "static/media/Bossa-Bold.7fe21d84.woff2";